(() => {
  "use strict";
  if (window.__HARDRIP_CHATTY_PREBOOT_HOME_V20230__) return;
  window.__HARDRIP_CHATTY_PREBOOT_HOME_V20230__ = true;

  const KEY = "avada-chatty/widget-page-setting";

  // Chatty persists its last FAQ/search tab for weeks. A stale currentTab=2
  // can reopen on Help instead of the Home tab, especially on iPhone Safari.
  // Do not touch customer chat sessions or any other Chatty storage keys.
  const normalizeClosedRoute = () => {
    try {
      const raw = window.localStorage.getItem(KEY);
      if (!raw) return;
      const first = JSON.parse(raw);
      const doubleEncoded = typeof first === "string";
      const saved = doubleEncoded ? JSON.parse(first) : first;
      if (!saved || typeof saved !== "object" || Array.isArray(saved)) return;
      const history = Array.isArray(saved.history) ? saved.history : [];
      if (saved.open === false && saved.currentPage === "homePage" &&
          saved.currentTab === 0 && history.length === 1 && history[0] === "homePage") return;
      const reset = {
        ...saved,
        open: false,
        currentPage: "homePage",
        currentTab: 0,
        history: ["homePage"]
      };
      const encoded = JSON.stringify(reset);
      window.localStorage.setItem(KEY, doubleEncoded ? JSON.stringify(encoded) : encoded);
    } catch (_) {
      // Safari private browsing or a malformed legacy entry must not break the store.
    }
  };

  // Run synchronously in <head>, before Shopify injects the Chatty app.
  normalizeClosedRoute();

  // Reset only on a new open. Never force navigation while customers use
  // FAQ articles, search, tracking or any other widget page.
  const beforeLauncherClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest("#Avada-FAQ_WidgetTrigger");
    if (!trigger) return;
    if (trigger.getAttribute("aria-expanded") === "true") return;
    normalizeClosedRoute();
  };

  document.addEventListener("pointerdown", beforeLauncherClick, true);
  document.addEventListener("click", beforeLauncherClick, true);
})();